import React from 'react';
import { Heart, MoreVertical } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CarCardProps {
  id: number;
  image: string;
  year: string;
  make: string;
  model: string;
  trim: string;
  price: string;
  mileage: string;
}
export function CarCard({
  id,
  image,
  year,
  make,
  model,
  trim,
  price,
  mileage
}: CarCardProps) {
  return <Link to={`/autos/${id}`} className="group bg-white rounded-xl border border-[#D5D5D5] hover:shadow-lg hover:border-[#4A90E2] transition-all duration-300 cursor-pointer flex flex-col h-full relative" data-id="element-11">
      {/* Image Section */}
      <div className="relative aspect-[4/3] w-full bg-[#E8E8E8] rounded-t-xl overflow-hidden" data-id="element-12">
        <img src={image} alt={`${year} ${make} ${model}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-13" />

        {/* Favorite Button */}
        <button onClick={e => e.preventDefault()} className="absolute top-3 right-3 p-2 rounded-full bg-white/50 hover:bg-white text-[#1C1C1C] hover:text-[#D4A800] transition-colors shadow-sm backdrop-blur-sm" data-id="element-14">
          <Heart className="w-5 h-5" strokeWidth={1.5} data-id="element-15" />
        </button>
      </div>

      {/* More Options Button (overlapping bottom edge of image) */}
      <div className="absolute right-4 top-[calc(75%-20px)] z-10" data-id="element-16">
        <button onClick={e => e.preventDefault()} className="w-10 h-10 rounded-full bg-white border border-[#D5D5D5] flex items-center justify-center text-[#1C1C1C] hover:text-[#4A90E2] hover:border-[#4A90E2] transition-colors shadow-md" data-id="element-17">
          <MoreVertical className="w-5 h-5" strokeWidth={1.5} data-id="element-18" />
        </button>
      </div>

      {/* Content Section */}
      <div className="p-4 pt-5 flex flex-col flex-grow" data-id="element-19">
        <h3 className="text-[15px] text-[#1C1C1C] mb-1 line-clamp-2" data-id="element-20">
          {year} {make} {model} {trim}
        </h3>

        <div className="mt-auto flex items-center gap-3" data-id="element-21">
          <span className="text-xl font-bold text-[#4A90E2]" data-id="element-22">{price}</span>
          <span className="text-[#C8C8C8] font-light text-sm" data-id="element-23">|</span>
          <span className="text-[15px] font-bold text-[#1C1C1C]" data-id="element-24">
            {mileage}
          </span>
        </div>
      </div>
    </Link>;
}